import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slice/authSlice';
import referReducer from './slice/referralSlice';
import passbookReducer from "./slice/passbookSlice"
import surveyReducer from "./slice/surveySlice"
import feedbackSurveyReducer from './slice/feedbackSlice';
export const store = configureStore({
  reducer: {
    auth :authReducer,
    feedbackSurvey: feedbackSurveyReducer,
    refer: referReducer,
    passbook: passbookReducer,
    assignedSurveys: surveyReducer,
  },
});